import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup} from "@angular/forms";
import {requiredFieldValidator} from "../../utils/validation/validators";
import {AuthManagerService} from "../../auth/auth-manager.service";
import {MatDialog} from "@angular/material/dialog";
import {LoginData} from "../../auth/auth.model";
import {RegisterDialogComponent} from "../../utils/nav-link/register-dialog/register-dialog.component";
import {NoopScrollStrategy} from "@angular/cdk/overlay";
import {PasswordRecoveryDialogComponent} from "../../utils/nav-link/password-recovery-dialog/password-recovery-dialog.component";

@Component({
  selector: 'app-home-screen',
  templateUrl: './home-screen.component.html',
  styleUrls: ['./home-screen.component.scss']
})
export class HomeScreenComponent implements OnInit {

  form: FormGroup;
  rememberMe: boolean = false;
  showError: boolean = false;

  @Input() text: string;
  @Input() linkTo: string;
  @Input() isLogin = false;
  @Output() login = new EventEmitter();

  constructor(
    private formBuilder: FormBuilder,
    private auth: AuthManagerService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    document.body.style.backgroundImage = "url('/assets/img/home_screen_crop.png')";
    document.body.style.backgroundRepeat = "no-repeat";
    document.body.style.backgroundSize = "cover";
    document.body.style.backgroundPosition = "center";

    this.form = this.formBuilder.group({
      customerNumber: ['', requiredFieldValidator()],
      username: ['', requiredFieldValidator()],
      password: ['', requiredFieldValidator()]
    });
  }

  submit() {
    event.stopPropagation();

    this.form.get('customerNumber').markAsTouched();
    this.form.get('username').markAsTouched();
    this.form.get('password').markAsTouched();

    if(this.form.valid) {
      let data: LoginData = {
        customerNumber: this.form.get("customerNumber").value,
        username: this.form.get("username").value,
        password: this.form.get("password").value,
        rememberMe: this.rememberMe
      };
      this.auth.login(data).subscribe(response => {
        if (response.success) {
          this.login.emit();
          window.location.reload();
        } else {
          this.showError = true;
        }
      });
    } else {
      this.showError = true;
    }
  }

  register() {
    this.dialog.open(RegisterDialogComponent, {
      width: '300px',
      scrollStrategy: new NoopScrollStrategy()
    });
  }

  passwordRecovery() {
    this.dialog.open(PasswordRecoveryDialogComponent, {
      width: '250px',
      scrollStrategy: new NoopScrollStrategy()
    });
  }
}
